import { render, staticRenderFns, recyclableRender, components } from "./assembleProduct.vue?vue&type=template&id=b0b36df6&"
var renderjs
import script from "./assembleProduct.vue?vue&type=script&lang=js&"
export * from "./assembleProduct.vue?vue&type=script&lang=js&"
import style0 from "./assembleProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/assembleProduct/assembleProduct.vue"
export default component.exports